<template>
  <div id="app">
    <Toast />
    <router-view />
  </div>
</template>

<script>
import Toast from "primevue/toast/Toast.vue";
import { sessionService } from "@/_services/session.service";

export default {
  name: "app",
  components: {
    Toast
  },
  mounted() {
    window.addEventListener("storage", this.handleStorageChange);
    sessionService.resumeSession();
  },
  beforeDestroy() {
    window.removeEventListener("storage", this.handleStorageChange);
  },
  methods: {
    // Keeps tabs in sync: if the session token is cleared in one tab
    // (manual logout, forced logout, refresh failure) every other tab
    // reflects it immediately instead of racing its own 401/expiry checks.
    handleStorageChange(event) {
      if (event.key === "token" && !event.newValue && this.$route.name !== "login") {
        this.$router.push({ name: "login" });
      }
    }
  }
};
</script>

<style>
#app {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}
.p-toast .p-toast-message.p-toast-message-success {
  background: var(--dark-expo) !important;
  border: solid var(--dark-expo-alpha) !important;
  border-width: 0 0 0 6px !important;
  color: var(--textactive) !important;
}

.p-toast .p-toast-message.p-toast-message-success .p-toast-message-icon,
.p-toast .p-toast-message.p-toast-message-success .p-toast-icon-close,
.p-toast .p-toast-message .p-toast-message-content .p-toast-message-text,
.p-toast
  .p-toast-message
  .p-toast-message-content
  .p-toast-message-text
  .p-toast-detail {
  color: var(--textactive) !important;
}
</style>
